// extracted by mini-css-extract-plugin
export default {"paragraph":"Gc922f2","bold":"G5df26a Gd6846a"};